import { FC, MouseEventHandler } from "react";
import "./style.scss";
import { RedoIcon, UndoIcon } from "../Custom/Buttons/ButtonIcons";

type undoRedoProps = {
  handleUndo: MouseEventHandler<HTMLButtonElement>;
  handleRedo: MouseEventHandler<HTMLButtonElement>;
  undoDisabled: boolean;
  redoDisabled: boolean;
};

const UndoRedoComponent: FC<undoRedoProps> = ({
  handleUndo,
  handleRedo,
  undoDisabled,
  redoDisabled,
}) => {
  return (
    <div className="undo-redo-container">
      <button
        className="undoButton"
        onClick={handleUndo}
        disabled={undoDisabled}
      >
        <UndoIcon disabled={undoDisabled} />
      </button>
      <button
        className="redoButton"
        onClick={handleRedo}
        disabled={redoDisabled}
      >
        <RedoIcon disabled={redoDisabled} />
      </button>
    </div>
  );
};

export default UndoRedoComponent;
